import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Products } from '@app/_models';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PageCategoryService } from '@services/page-category.service';
import { ShopSidebarService } from '@services/shop-sidebar.service';
import * as _ from 'lodash';
import { ceil } from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { filter, pairwise, startWith } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationComponent } from '../../shared/components/pagination/pagination.component';
import { ProductCardNewComponent } from '../../shared/components/product-card-new/product-card-new.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf, NgFor, AsyncPipe } from '@angular/common';

export type Layout = 'grid' | 'grid-with-features' | 'list';
@UntilDestroy()
@Component({
    selector: 'app-products-view',
    templateUrl: './products-view.component.html',
    styleUrls: ['./products-view.component.scss'],
    standalone: true,
    imports: [NgClass, ExtendedModule, FormsModule, ReactiveFormsModule, NgIf, IconComponent, NgFor, ProductCardNewComponent, PaginationComponent, AsyncPipe, TranslateModule]
})
export class ProductsViewComponent implements OnInit {
    @Input() layout: Layout = 'grid';
    @Input() offcanvas: 'always' | 'mobile' = 'mobile';

    listOptionsForm: UntypedFormGroup = this.fb.group({
        page: this.fb.control(this.pageService.page),
        limit: this.fb.control(this.pageService.limit),
        sort: this.fb.control(this.pageService.sort),
    });

    filtersCount = 0;

    @Input() products: Products[];
    @Input() productsCount;
    @Input() displayFilters = true;
    @Input() filtersButton = 'filters';
    @Input() showSidebar = 'true';
    @Input() itemsView = 'default';
    @Output() requestParams: EventEmitter<any> = new EventEmitter();
    paginationPageCount: number;
    list = {
        from: 0,
        to: 0
    }


    constructor(
        private fb: UntypedFormBuilder,
        public sidebar: ShopSidebarService,
        public pageService: PageCategoryService,
        private route: ActivatedRoute,
        private router: Router,
        private deviceDetector: DeviceDetectorService
    ) { }


    currentUrl;

    ngOnInit(): void {

        this.currentUrl = this.router.url.split('?')[0];
        if (this.itemsView == 'property') {
            this.layout = 'list';
        }

        this.paginationPageCount = ceil(this.productsCount / this.pageService.limit);
        this.list = {
            from: (this.pageService.page * this.pageService.limit) - (this.pageService.limit - 1),
            to: _.min([this.pageService.page * this.pageService.limit, this.productsCount])
        }
        this.listOptionsForm.valueChanges.pipe(untilDestroyed(this), startWith(this.listOptionsForm.value), pairwise())
            .subscribe(([prev, next]: [any, any]) => {
                if (prev.sort != next.sort || prev.limit != next.limit) {
                    this.listOptionsForm.get('page').patchValue(1, { emitEvent: false })
                }
                this.pageChange();
            });

        if (this.deviceDetector.isMobile()) {
            this.setLayout('list');
        }
    }

    pageChange() {
        const pagination = this.listOptionsForm.value;
        this.pageService.updateOptions(pagination);
        let filterParams = this.route.snapshot.queryParams;

        if (filterParams) {
            filterParams = _.clone(filterParams);
            filterParams.page = pagination.page;
            filterParams.limit = pagination.limit
            filterParams.sort = pagination.sort
        } else {
            filterParams = {
                page: this.pageService.page,
                limit: this.pageService.limit,
                sort: this.pageService.sort
            };
        }

        this.list = {
            from: (this.pageService.page * this.pageService.limit) - (this.pageService.limit - 1),
            to: _.min([this.pageService.page * this.pageService.limit, this.productsCount])
        }

        this.requestParams.emit(filterParams);
        return this.router.navigate(
            [],
            {
                relativeTo: this.route,
                queryParams: filterParams,
                queryParamsHandling: '',
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.itemsView?.currentValue) {
            if (this.itemsView == 'property') {
                this.layout = 'list';
            } else {
                this.layout = 'grid';
            }
        }
        if (!this.route.snapshot.queryParams.sort) {
            this.listOptionsForm.get('sort').setValue('popular', { emitEvent: false });
            this.currentUrl = this.router.url.split('?')[0];
        };

        this.paginationPageCount = ceil(this.productsCount / this.pageService.limit);
        this.list = {
            from: (this.pageService.page * this.pageService.limit) - (this.pageService.limit - 1),
            to: _.min([this.pageService.page * this.pageService.limit, this.productsCount])
        }
    }


    setLayout(value: Layout): void {
        this.layout = value;
    }

    resetFilters(): void {
        this.pageService.updateOptions({ filterValues: {} });
    }
}
